// import CadencierService from '@/services/CadencierService'
import moment from 'moment'
import { TracabiliteService } from '@/services/TracabiliteService'

export const state = {
  loading: false,
  imageList: [],
  globalImageList: [],
  categories: [],
  date: moment().format('YYYY-MM-DD'),
}

export const mutations = {
  setImageLoading(currentState, loading) {
    currentState.tracabilite.loading = loading
  },
  setImageList(currentState, imageList) {
    currentState.tracabilite.imageList = imageList.images
  },
  setGlobalImageList(currentState, imageList) {
    currentState.tracabilite.globalImageList = imageList.images
  },
  setTracabiliteDate(currentState, date) {
    currentState.tracabilite.date = date
  },
  setCategories(currentState, categories) {
    currentState.tracabilite.categories = categories
  },
}

export const actions = {
  setTracabiliteDate({ commit }, date) {
    commit('setTracabiliteDate', date)
  },
  loadGlobalImageList({ commit, rootState, getters }) {
    return TracabiliteService.getCalendar(rootState.context.currentContext, getters.contextClientId).then(images => {
      commit('setGlobalImageList', { images })
    })
  },
  loadImageList({ commit, rootState, getters }) {
    commit('setImageLoading', true)
    return TracabiliteService.getByDate(rootState.context.currentContext, getters.contextClientId, rootState.tracabilite.date)
      .then(images => {
        const urls = images.map((paylaod) => ({ ...paylaod, url: TracabiliteService.getImg(rootState.context.currentContext, paylaod.name) }))
        commit('setImageLoading', false)
        commit('setImageList', { images: urls })
      })
  },
  loadCategories({ commit, rootState }) {
    return TracabiliteService.getCategories(rootState.context.currentContext)
      .then(categories => {
        commit('setCategories', categories)
      })
  },
}
export default { state, actions, mutations }
